import { UserPortalAuthData } from './local-storage-auth-data.interface';

export const USER_PORTAL_AUTH_DATA_ITEM = 'user_portal_authentication_data';

export const USER_PORTAL_AUTH_DATA_EMPTY: UserPortalAuthData = {
  expirationDate: null,
  sessionEndedAt: null,
  sessionStatedAt: null,
};
